import type {
  AnalyticsTrendsResponse,
  AnalyticsBreakdownResponse,
  AnalyticsProjectionsResponse,
  AnalyticsRecordsResponse,
  AnalyticsVisitsResponse,
} from "@atlas/shared";
import { apiGet } from "../lib/api-client";

export type {
  AnalyticsTrendBucket,
  AnalyticsTrendsResponse,
  AnalyticsSourceBreakdownRow,
  AnalyticsRegionBreakdownRow,
  AnalyticsBreakdownResponse,
  AnalyticsProjection,
  AnalyticsProjectionsResponse,
  AnalyticsRecordActivity,
  AnalyticsHighestSummit,
  AnalyticsRecords,
  AnalyticsRecordsResponse,
  AnalyticsVisitItemType,
  AnalyticsVisitTotals,
  AnalyticsVisitYear,
  AnalyticsMostVisitedItem,
  AnalyticsVisitMoment,
  AnalyticsVisits,
  AnalyticsVisitsResponse,
} from "@atlas/shared";

// ANA-2 — Insights panels on StatisticsPage. These endpoints are Pro-gated
// (402 upgradeRequired); only ever call them for Pro users (free users see a
// seeded-fake preview behind <ProGate>, so no 402 round-trip happens).

export function fetchAnalyticsTrends(
  bucket: "month" | "year" = "month",
  /** MM-DD same-date cutoff for the year-vs-year view. */
  toDate?: string,
): Promise<AnalyticsTrendsResponse> {
  const q = toDate ? `&toDate=${encodeURIComponent(toDate)}` : "";
  return apiGet(`/analytics/trends?bucket=${bucket}${q}`);
}

export function fetchAnalyticsBreakdown(
  dimension: "region" | "source" = "region",
): Promise<AnalyticsBreakdownResponse> {
  return apiGet(`/analytics/breakdown?dimension=${dimension}`);
}

export function fetchAnalyticsProjections(): Promise<AnalyticsProjectionsResponse> {
  return apiGet("/analytics/projections");
}

export function fetchAnalyticsRecords(): Promise<AnalyticsRecordsResponse> {
  return apiGet("/analytics/records");
}

export function fetchAnalyticsVisits(): Promise<AnalyticsVisitsResponse> {
  return apiGet("/analytics/visits");
}
